import { Bridge } from "../../types/bridge";
import { CalculationResult } from "../../types/calculations";
import {
  BRIDGE_TYPES,
  calculateBridgeCost,
  calculateBridgeWeight,
} from "../../constants/bridges";

export interface BridgeStats {
  cost: number;
  tons: number;
  power: number;
  maintenanceCost: number;
}

export const calculateBridgeStats = (
  bridge: Bridge,
  shipSize: number,
): CalculationResult<BridgeStats> => {
  if (!bridge || !bridge.type) {
    return {
      success: false,
      error: {
        type: "INVALID_INPUT",
        message: "Bridge type must be selected.",
      },
    };
  }

  const bridgeSpec = BRIDGE_TYPES[bridge.type];

  if (!bridgeSpec) {
    return {
      success: false,
      error: {
        type: "CALCULATION_ERROR",
        message: `Invalid bridge type: ${bridge.type}`,
      },
    };
  }

  // Calculate cost and weight using Traveller ruleset functions
  const cost = calculateBridgeCost(bridge.type, shipSize);
  const tons = calculateBridgeWeight(bridge.type, shipSize);
  const power = bridgeSpec.power;
  const maintenanceCost = Math.floor(cost * 0.01); // 1% of bridge cost

  return {
    success: true,
    data: {
      cost,
      tons,
      power,
      maintenanceCost,
    },
  };
};
